import { z } from 'zod'
import { demo, dev, prodEU, prodSandbox, prodUS, sit, test } from './envvars.ts'

const getEnvVars = () => {
	const mode = import.meta.env.MODE
	const envs = {
		ENABLE_QUERY_CACHE: z
			.string()
			.optional()
			.transform((enabled) => enabled === 'true')
			.parse(import.meta.env.VITE_ENABLE_QUERY_CACHE),
		PR_PREVIEW: z
			.string()
			.optional()
			.transform((enabled) => enabled === 'true')
			.parse(import.meta.env.VITE_PR_PREVIEW),
		MAPBOX_SECRET: z.string().parse(import.meta.env.VITE_MAPBOX_SECRET),
		XWEATHER_SECRET: z.string().parse(import.meta.env.VITE_XWEATHER_SECRET),
	}
	if (mode === 'dev') return { ...envs, ...dev }
	if (mode === 'test') return { ...envs, ...test }
	if (mode === 'demo') return { ...envs, ...demo }
	if (mode === 'sit') return { ...envs, ...sit }
	if (mode === 'prod-sandbox') return { ...envs, ...prodSandbox }
	if (mode === 'prod-eu') return { ...envs, ...prodEU }
	if (mode === 'prod-us') return { ...envs, ...prodUS }
	throw new Error(`unknown mode ${mode}`)
}
export const env = getEnvVars()
